import { get } from './apiService';

/**
 * Get all organizations
 * @returns {Promise<Array>} List of organizations
 */
export async function getOrganizations() {
  return await get('/organizations');
}

/**
 * Get single organization by ID
 * @param {string} org_id - Organization ID
 * @returns {Promise<object>} Organization data with screens
 */
export async function getOneOrganization(org_id) {
  return await get(`/organizations/${org_id}`);
}

